import * as Yup from "yup";

type IGradeSchema = {
  name: string;
};

const gradeSchema: Yup.ObjectSchema<IGradeSchema> = Yup.object().shape({
  name: Yup.string().required("Grade name is required."),
});

export { gradeSchema };
export type { IGradeSchema };
